/** Teks halaman /admin/server-log & kartu "Error 24 jam" (id/en). `{n}`/`{h}` = angka. */

export interface ServerLogText {
	title: string;
	description: string;
	nav: { label: string; description: string };
	card: {
		title: string;
		errors: string;
		warns: string;
		none: string;
		top: string;
		open: string;
		failed: string;
		hours: string;
	};
	filters: {
		search: string;
		level: string;
		module: string;
		status: string;
		range: string;
		all: string;
		export: string;
		reset: string;
	};
	levels: Record<string, string>;
	statuses: Record<string, string>;
	columns: {
		level: string;
		module: string;
		title: string;
		count: string;
		lastSeen: string;
		status: string;
	};
	empty: string;
	loadFailed: string;
	total: string;
	detail: {
		firstSeen: string;
		lastSeen: string;
		count: string;
		entries: string;
		stack: string;
		noEntries: string;
		note: string;
		notePlaceholder: string;
		handled: string;
		ignore: string;
		reopen: string;
		saved: string;
		saveFailed: string;
		regressed: string;
		fingerprint: string;
		route: string;
		user: string;
		close: string;
	};
}

export const serverLogTexts: Record<"id" | "en", ServerLogText> = {
	id: {
		title: "Server Log",
		description:
			"Error & peringatan server yang dikelompokkan otomatis (disimpan 30 hari)",
		nav: {
			label: "Server Log",
			description: "Error & peringatan server terkelompok",
		},
		card: {
			title: "Error 24 jam",
			errors: "{n} grup error",
			warns: "{n} grup peringatan",
			none: "Tidak ada error dalam {h} jam terakhir",
			top: "Paling sering",
			open: "Buka Server Log",
			failed: "Ringkasan log tidak tersedia",
			hours: "jam",
		},
		filters: {
			search: "Cari pesan / modul",
			level: "Level",
			module: "Modul",
			status: "Status",
			range: "Rentang waktu",
			all: "Semua",
			export: "Ekspor CSV",
			reset: "Atur ulang",
		},
		levels: { warn: "Peringatan", error: "Error", fatal: "Fatal" },
		statuses: {
			open: "Terbuka",
			resolved: "Ditangani",
			ignored: "Diabaikan",
			regressed: "Muncul lagi",
		},
		columns: {
			level: "Level",
			module: "Modul",
			title: "Pesan",
			count: "Jumlah",
			lastSeen: "Terakhir",
			status: "Status",
		},
		empty: "Tidak ada log yang cocok dengan filter",
		loadFailed: "Gagal memuat server log",
		total: "{n} grup",
		detail: {
			firstSeen: "Pertama terlihat",
			lastSeen: "Terakhir terlihat",
			count: "Total kejadian",
			entries: "Kejadian terbaru",
			stack: "Stack trace",
			noEntries: "Belum ada kejadian tersimpan (disampel)",
			note: "Catatan",
			notePlaceholder: "Catatan penanganan (opsional)",
			handled: "Tandai ditangani",
			ignore: "Abaikan",
			reopen: "Buka lagi",
			saved: "Status diperbarui",
			saveFailed: "Gagal memperbarui status",
			regressed: "Muncul lagi setelah ditandai ditangani",
			fingerprint: "Sidik jari",
			route: "Rute",
			user: "ID pengguna",
			close: "Tutup",
		},
	},
	en: {
		title: "Server Log",
		description:
			"Server errors & warnings grouped automatically (kept for 30 days)",
		nav: {
			label: "Server Log",
			description: "Grouped server errors & warnings",
		},
		card: {
			title: "Errors (24 h)",
			errors: "{n} error groups",
			warns: "{n} warning groups",
			none: "No errors in the last {h} hours",
			top: "Most frequent",
			open: "Open Server Log",
			failed: "Log summary unavailable",
			hours: "h",
		},
		filters: {
			search: "Search message / module",
			level: "Level",
			module: "Module",
			status: "Status",
			range: "Time range",
			all: "All",
			export: "Export CSV",
			reset: "Reset",
		},
		levels: { warn: "Warning", error: "Error", fatal: "Fatal" },
		statuses: {
			open: "Open",
			resolved: "Resolved",
			ignored: "Ignored",
			regressed: "Regressed",
		},
		columns: {
			level: "Level",
			module: "Module",
			title: "Message",
			count: "Count",
			lastSeen: "Last seen",
			status: "Status",
		},
		empty: "No logs match the filters",
		loadFailed: "Failed to load server log",
		total: "{n} groups",
		detail: {
			firstSeen: "First seen",
			lastSeen: "Last seen",
			count: "Total occurrences",
			entries: "Latest occurrences",
			stack: "Stack trace",
			noEntries: "No stored occurrences yet (sampled)",
			note: "Note",
			notePlaceholder: "Handling note (optional)",
			handled: "Mark handled",
			ignore: "Ignore",
			reopen: "Reopen",
			saved: "Status updated",
			saveFailed: "Failed to update status",
			regressed: "Reappeared after being marked handled",
			fingerprint: "Fingerprint",
			route: "Route",
			user: "User ID",
			close: "Close",
		},
	},
};
